// removed by extract-text-webpack-plugin
module.exports = {"update-link":"bngEi","active":"_3BUcV","inactive":"_1ZODS","icon":"zQWkW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdateNavLink/RichUpdatesNavIcon.scss
// module id = ./src/components/RichUpdates/RichUpdateNavLink/RichUpdatesNavIcon.scss
// module chunks = 5